import React from 'react'
import ImageList from '../../components/images/image-list'

export default function ImagesHotPage(): React.ReactElement {
   return <ImageList filter={'hot'} />
}
